import axios from 'axios';
import { toCpaProductsModel } from '../../mappers/cpa/toCpaProductsModel';
import { toCpaProductsSuggestModel } from '../../mappers/cpa/toCpaProductsSuggestModel';
import { toCpaShopsModel } from '../../mappers/cpa/toCpaShopsModel';
import { toCpaShopsSuggestModel } from '../../mappers/cpa/toCpaShopsSuggestModel';
import { toWalletInfoModel } from '../../mappers/cpa/toWalletInfoModel';
import type {
    CpaProductsModel,
    CpaShopsModel,
    CpaSearchSuggestModel,
    CpaStatus,
    CpaStatusAfterSubmit,
    WalletInfoModel,
} from './types';

export async function loadWalletInfo(): Promise<WalletInfoModel | undefined> {
    const response = await axios.get('/user/wallet_info');

    return toWalletInfoModel(response.data);
}

export async function postCpaStatus(data: CpaStatusAfterSubmit): Promise<{ data: CpaStatus }> {
    const response = await axios.post('/user/cpa_status/', data);

    return response.data;
}

export async function loadCpaShops(text: string, page?: number): Promise<CpaShopsModel> {
    const queryParams = new URLSearchParams();

    queryParams.set('text', text);
    page && queryParams.set('page', String(page));

    const response = await axios.get(`/cpa/shops?${queryParams.toString()}`);

    return { items: toCpaShopsModel(response.data.ST_HOMEPAGE) };
}

export async function loadCpaShopsSuggest(text?: string): Promise<CpaSearchSuggestModel[]> {
    const queryParams = new URLSearchParams();
    text && queryParams.set('text', text);

    const response = await axios.get(`/cpa/shops_suggest?${queryParams.toString()}`);

    return toCpaShopsSuggestModel(response.data.ST_HOMEPAGE);
}

export async function loadCpaShopsRecomendations(page?: number): Promise<CpaShopsModel> {
    const queryParams = new URLSearchParams();

    page && queryParams.set('page', String(page));

    const response = await axios.get(`/cpa/shops_recommendation?${queryParams.toString()}`);

    return { items: toCpaShopsModel(response.data.ST_HOMEPAGE) };
}

export async function loadCpaProductsRecommendations(page?: number): Promise<CpaProductsModel> {
    const queryParams = new URLSearchParams();

    page && queryParams.set('page', String(page));

    const response = await axios.get(`/cpa/products_recommendation?${queryParams.toString()}`);

    return { items: toCpaProductsModel(response.data.ST_GOOD) };
}

export async function loadCpaProducts(text: string, page?: number): Promise<CpaProductsModel> {
    const queryParams = new URLSearchParams();

    queryParams.set('text', text);
    page && queryParams.set('page', String(page));

    const response = await axios.get(`/cpa/products?${queryParams.toString()}`);

    return { items: toCpaProductsModel(response.data.ST_GOOD) };
}

export async function loadCpaProductsSuggest(text?: string): Promise<CpaSearchSuggestModel[]> {
    const queryParams = new URLSearchParams();
    text && queryParams.set('text', text);

    const response = await axios.get(`/cpa/products_suggest?${queryParams.toString()}`);

    return toCpaProductsSuggestModel(response.data.ST_GOOD);
}
